import { ReactNode } from "react";

interface FaqLayoutProps {
  title: ReactNode;
  children: ReactNode;
  className?: string;
}

export const FaqLayout = ({
  title,
  children,
  className = "",
}: FaqLayoutProps) => {
  return (
    <div className={`relative w-full min-h-screen bg-brand-black ${className}`}>
      <div color="bg-brand-red" />

      <div className="relative grid-container py-20 dsk:py-32">
        <div className="col-span-full dsk:col-start-2">
          <h2 className="text-heading-2 text-brand-cream text-left mb-16 font-bold">
            {title}
          </h2>

          <div className="flex flex-col items-start">{children}</div>
        </div>
      </div>
    </div>
  );
};
